import React from 'react';
import { Header } from '../components/Header';
import { ApproachSection } from '../components/ApproachSection';
import { BeliefSection } from '../components/BeliefSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-261">
      <Header data-id="element-262" />
      <main data-id="element-263">
        <ApproachSection data-id="element-264" />
        <BeliefSection data-id="element-265" />
        <ServicesSection data-id="element-266" />
        <WhyChooseUsSection data-id="element-267" />
        <TestimonialsSection data-id="element-268" />
        <ContactForm data-id="element-269" />
      </main>
      <Footer data-id="element-270" />
    </div>;
}